export const PI_PHASES = {
  initiation: {
    key: 'initiation',
    label: 'Project Initiation',
    listPath: '/sourcing/project-intelligence/initiation',
    description: 'Kickoff the project, fill structured fields, and collect team contributions.',
    routeSegment: 'initiation',
  },
  builder: {
    key: 'builder',
    label: 'DPR Builder',
    listPath: '/sourcing/project-intelligence/builder',
    description: 'AI drafts DPR sections from the project brief. Review and edit inline.',
    routeSegment: 'builder',
  },
  regulatory: {
    key: 'regulatory',
    label: 'Regulatory Approvals',
    listPath: '/sourcing/project-intelligence/regulatory',
    description: 'Track regulatory clearances, uploads, and due dates.',
    routeSegment: 'regulatory',
  },
  finalisation: {
    key: 'finalisation',
    label: 'DPR Finalisation',
    listPath: '/sourcing/project-intelligence/finalisation',
    description: 'Review the consolidated DPR before moving to Pre-RFP.',
    routeSegment: 'finalisation',
  },
};

export const PI_PHASE_ORDER = ['initiation', 'builder', 'regulatory', 'finalisation'];

export const getPiWorkspacePath = (phaseKey, projectId) => {
  const phase = PI_PHASES[phaseKey];
  if (!phase || !projectId) return phase?.listPath || '/sourcing/project-intelligence';
  return `/sourcing/project-intelligence/${phase.routeSegment}/${projectId}`;
};
